import { AnyAction } from 'redux';
import { ActionsReport } from '../../Actions/Report/Types';
import { Producer, SummaryProducer, ShipmentSummary, StageProducer, createStages } from '../../Models/Report';

export interface IReportState {
	producers: Producer[];
	isRequestDashboard: boolean;
	isRequestAnnounced: boolean;
	isRequestShipment: boolean;
	shipmentSummary?: ShipmentSummary;
	announced?: SummaryProducer;
	stageProducer: StageProducer[];
}

const initialState = {
	producers: [],
	isRequestDashboard: false,
	isRequestAnnounced: false,
	isRequestShipment: false,
	producerAnnounced: undefined,
	branchAnnounced: undefined,
	announced: undefined,
	shipmentSummary: undefined,
	stageProducer: []
};

const asyncReducer = (
	state: IReportState = initialState,
	action: AnyAction
) => {
	switch (action.type) {
		case ActionsReport.REQUEST_REPORT_DASHBOARD:
			return {...state, isRequestDashboard: !state.isRequestDashboard };
		case ActionsReport.SET_PRODUCERS:
			const producers = action.payload as Producer[];
			const stagesProducerNew = producers.map(p => {
				const s = new StageProducer();
				s.producer = p;
				s.stages = createStages();
				return s;
			})
			return {...state, producers, stageProducer: stagesProducerNew, isRequestDashboard: false };
		case ActionsReport.SET_STAGES:
			const summaryStage = action.payload as SummaryProducer;
			const indexProducer = state.stageProducer.findIndex(p => p.producer.id === summaryStage.idProducer);
			const stages = state.stageProducer[indexProducer].stages;
			const indexStage = stages.findIndex(s => s.report === summaryStage.report);
			stages[indexStage].data = summaryStage;
			stages[indexStage].loading = false;
			const stagesNew = [...stages];
			const productersEditStage: StageProducer = {...state.stageProducer[indexProducer], stages: stagesNew };
			const producersNewStage = [...state.stageProducer] as StageProducer[];
			producersNewStage[indexProducer] = productersEditStage
			return {...state, stageProducer: producersNewStage };
		case ActionsReport.SET_SUMMARY:
			const summary = action.payload as SummaryProducer;
			const index = state.producers.findIndex(p => p.id === summary.idProducer);
			const producterEdit: Producer = {...state.producers[index], loading: false, summary };
			const producersNew = [...state.producers] as Producer[];
			producersNew[index] = producterEdit
			return {...state, producers: producersNew };
		case ActionsReport.FETCH_SHIPMENT:
			return {...state, shipmentSummary: action.payload };
		case ActionsReport.REQUEST_ANNOUNCED:
			return {...state, isRequestAnnounced: !state.isRequestAnnounced }
		case ActionsReport.REQUEST_SHIPMENT:
			return {...state, isRequestShipment: !state.isRequestShipment }
		case ActionsReport.FETCH_ANNOUNCED_LOAD:
			return {...state, announced: action.payload };
	}
	return state;
};

export default asyncReducer;
